export enum ValorizationType {
    Adminission = 2,
    Billing = 3
}
